"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concat = void 0;
const is_array_1 = require("./is-array");
exports.concat = (...values) => {
    const result = [];
    for (let i = 0; i < values.length; i++) {
        const item = values[i];
        if (is_array_1.isArray(item)) {
            const childLength = item.length;
            for (let j = 0; j < childLength; j++) {
                result.push(item[j]);
            }
        }
        else {
            result.push(item);
        }
    }
    return result;
};
//# sourceMappingURL=concat.js.map